import React, { useEffect } from 'react'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomCards from '../Components/CustomCards/CustomCards'
import CustomTable from '../Components/CustomTable/CustomTable'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Badge, Container } from 'react-bootstrap'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { useDispatch, useSelector } from 'react-redux'
import { fetchStudents } from '../hooks/students'
import { useNavigate } from 'react-router-dom'

function Students() {
  const dispatch=useDispatch();
  const navigate=useNavigate()
      const  {list}  = useSelector((state) => state.students);
const downloadExcel = () => {
  if (!list || list.length === 0) return;

  const data = list.map((item) => ({
    "المستفيد": item?.name,
    "اسم المستخدم": item?.username,
    "الرقم العسكري": item?.military_number,
    "اسم المطعم": item?.restaurant?.name,
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(fileData, "students.xlsx");
};
      useEffect(() => {
      dispatch(fetchStudents())
      }, [dispatch])
  const header=[
    "المستفيد",
    "اسم المستخدم",
    "الرقم العسكري",
    "اسم المطعم",
""

  ]

  const body=<tbody>
    {list?.map((item)=>{
      console.log(item);
      
      return(
    <tr>
      <td>{item?.name}</td>
      <td>{item?.username}</td>
      <td>{item?.military_number}</td>
      <td>{item?.restaurant?.name}</td>
      <td><Badge onClick={()=>navigate(`/dashboard/edit-student/${item?.id}`)} bg='primary'>تعديل</Badge></td>
    </tr>
    

      )
    })}
  </tbody>
  return (
    <div>
    <AuthNavbar/>
      <Container>
        <CustomHeader
          title={"الالتحاق بالأكاديمية"}
          subtitle={"إدارة 1248 مستفيدًا نشطًا في برامج فنون الطهي"}
          downloadData={true}
          addData={true}
                    status={"student"}
                              downloadFunction={downloadExcel}



        />
        {/* <CustomCards
          data={data}
        /> */}
        <CustomTable
          data={list}
          fiteration={[]}
          currentData={25}
          allData={' 1,248  مستفيد'}
                    header={header}
          status={"student"}
          body={body}

        />
      <CustomPagination
          currentData={25}
          allData={list?.length}

        />
      </Container>
    </div>
  )
}

export default Students